// Credits and licences (rebuild.md §8.5).
import { Screen } from './Shell.tsx';

export function Credits() {
  return (
    <Screen title="Credits" back="/settings" class="credits">
      <CreditsBody />
    </Screen>
  );
}

/** The credits themselves (also rolled after the Epilogue, on the end card). */
export function CreditsBody() {
  return (
    <>
      <section>
        <h2>Forge &amp; Co.: Last Reagent</h2>
        <p>A chemistry game in seventeen chapters, built on the anime and graphic novel of the same name.</p>
      </section>
      <section>
        <h2>Curriculum</h2>
        <p>
          Aligned to the <em>Chemistry General Senior Syllabus 2025 v1.3</em>. Syllabus content paraphrased and the
          <em> Chemistry 2025 Formula and data book</em> values used under licence: © State of Queensland (QCAA)
          2025–2026, licensed CC BY 4.0, www.qcaa.qld.edu.au/copyright.
        </p>
      </section>
      <section>
        <h2>Film and graphic novel</h2>
        <ul>
          <li>The anime: keyframes and character sheets generated with OpenAI image models; animation by Higgsfield (Kling 2.5 Turbo Pro and Kling 3.0 Turbo); dub, score and effects with ElevenLabs; typography and compositing in code.</li>
          <li>The graphic novel: pages and panels built from the anime’s art, with a new cover and four splash pages.</li>
          <li>Game assets generated at build time with the same services (images, voice lines, lab sounds and short loops), reviewed and recorded with provenance.</li>
        </ul>
      </section>
      <section>
        <h2>Voices</h2>
        <ul>
          <li>The Operator: River</li>
          <li>Hilda Solnes: Evelyn</li>
          <li>Mei Tran: Nixie</li>
          <li>Director Vance Kirov: Alexey</li>
          <li>M.: august (processed)</li>
          <li>ECHO: Sigma Centauri</li>
          <li>The Guide: Rob (cast for a storytelling style, not to imitate anyone)</li>
          <li>Bureau System: Silent Systemus · Bureau Courier: Daniel</li>
        </ul>
      </section>
      <section>
        <h2>Fonts (SIL Open Font License 1.1)</h2>
        <ul>
          <li>Atkinson Hyperlegible Next (Braille Institute)</li>
          <li>Bangers</li>
          <li>Comic Neue</li>
          <li>Barlow Semi Condensed</li>
          <li>Cascadia Mono (Microsoft)</li>
          <li>Cormorant Garamond</li>
          <li>Lexend</li>
        </ul>
      </section>
      <section>
        <h2>Software</h2>
        <p>Preact, @preact/signals, wouter, idb-keyval, zod, Workbox and Vite (MIT / Apache-2.0).</p>
      </section>
    </>
  );
}
